/* =========================================================================
   VD · MOTION « DE LA FLEUR AU COLIS »
   Timeline en millisecondes absolus. Le script ne fait que poser et retirer
   des classes ; toute l'animation vit dans la feuille de style, et ne touche
   que « transform » et « opacity ».

   Trois mecanismes :
   1. fit()        met le canevas fixe a l'echelle de la largeur disponible ;
   2. jouer()      enchaine les huit etapes sur une horloge absolue ;
   3. envoler()    morphing FLIP mesure au getBoundingClientRect : la photo
                   de l'etape qui se termine vole vers son repere sur la
                   ligne de temps et y reste en vignette.
   ========================================================================= */
(function () {
  "use strict";

  var VITESSES = { pose: 1.28, normal: 1, vif: 0.78 };

  function demarrer(racine) {
    if (racine.getAttribute("data-vm-pret") === "1") { return; }
    racine.setAttribute("data-vm-pret", "1");

    var viewport = racine.querySelector(".vm-viewport");
    var canvas   = racine.querySelector(".vm-canvas");
    var rail     = racine.querySelector(".vm-rail");
    var railFill = racine.querySelector(".vm-rail-fill");
    var fly      = racine.querySelector(".vm-fly");
    var final    = racine.querySelector(".vm-final");
    var replay   = racine.querySelector(".vm-replay");
    var video    = racine.querySelector(".vm-video");

    var shots  = racine.querySelectorAll(".vm-shot");
    var caps   = racine.querySelectorAll(".vm-cap");
    var blocks = racine.querySelectorAll(".vm-block");
    var nums   = racine.querySelectorAll(".vm-n");
    var slots  = racine.querySelectorAll(".vm-slot");
    var labs   = racine.querySelectorAll(".vm-lab");

    var N = shots.length;
    if (!N || !canvas || !viewport) { return; }

    var boucle = racine.getAttribute("data-boucle") !== "0";
    var k = VITESSES[racine.getAttribute("data-vitesse")] || 1;

    var ETAPE   = Math.round(2600 * k);   // duree d'une etape
    var DEPART  = Math.round(700 * k);    // avant la premiere etape
    var ENVOL   = Math.round(2020 * k);   // instant du morphing dans l'etape
    var POSE    = Math.round(700 * k);    // duree du morphing
    var FIN     = Math.round(1500 * k);   // apres la derniere vignette
    var REPRISE = Math.round(4200 * k);   // pause avant de rejouer

    /* ------------------------------------------------ mise a l'echelle */
    var SCALE = 1;
    var derniereLargeur = -1;
    var derniereHauteur = -1;

    function fit() {
      var w = viewport.clientWidth;
      var cw = canvas.offsetWidth;      /* non affecte par transform:scale */
      var ch = canvas.offsetHeight;
      if (!w || !cw) { return; }
      if (w === derniereLargeur && ch === derniereHauteur) { return; }
      derniereLargeur = w;
      derniereHauteur = ch;
      /* Le plafond d'agrandissement vient de la feuille de style : le
         canevas telephone peut grandir jusqu'a une tablette, le canevas
         large reste a sa taille nominale. */
      var max = parseFloat(getComputedStyle(canvas).getPropertyValue("--vm-max")) || 1;
      SCALE = Math.min(max, w / cw);
      canvas.style.transform = "scale(" + SCALE + ")";
      canvas.style.left = Math.round(Math.max(0, (w - cw * SCALE) / 2)) + "px";
      viewport.style.height = Math.round(ch * SCALE) + "px";
    }
    fit();
    window.addEventListener("resize", fit);
    window.addEventListener("load", fit);
    if (window.ResizeObserver) { new ResizeObserver(fit).observe(viewport); }

    /* -------------------------------------------------- horloge absolue */
    var minuteries = [];
    function a(ms, fn) { minuteries.push(setTimeout(fn, ms)); }
    function arreter() {
      for (var i = 0; i < minuteries.length; i++) { clearTimeout(minuteries[i]); }
      minuteries = [];
    }

    function nettoyer(liste) {
      for (var i = 0; i < liste.length; i++) {
        liste[i].classList.remove("is-on", "is-past");
      }
    }

    function remiseAZero() {
      arreter();
      nettoyer(shots); nettoyer(caps); nettoyer(blocks); nettoyer(nums);
      for (var i = 0; i < slots.length; i++) {
        slots[i].classList.remove("is-done", "is-now");
        labs[i] && labs[i].classList.remove("is-done", "is-now");
      }
      railFill.style.transform = "scaleX(0)";
      final.classList.remove("is-on");
      fly.classList.remove("is-live", "is-anim", "is-fade");
      fly.removeAttribute("style");
      if (video) { try { video.pause(); video.currentTime = 0; } catch (e) {} }
    }

    /* --------------------------------------------- chargement progressif
       Les photos des etapes 3 a 8 portent leur adresse dans data-src : elles
       ne sont demandees qu'une etape a l'avance. Un visiteur qui ne descend
       jamais jusqu'ici ne telecharge rien. */
    function precharger(i) {
      if (i < 0 || i >= N) { return; }
      var cibles = [];
      var a1 = shots[i].querySelector("img[data-src]");
      var a2 = slots[i] ? slots[i].querySelector("img[data-src]") : null;
      if (a1) { cibles.push(a1); }
      if (a2) { cibles.push(a2); }
      for (var j = 0; j < cibles.length; j++) {
        armerReprise(cibles[j], cibles[j].getAttribute("data-src"));
        cibles[j].src = cibles[j].getAttribute("data-src");
        cibles[j].removeAttribute("data-src");
      }
    }

    /* Un alea de reseau laissait parfois une vignette en icone cassee.
       On redemande l adresse une seule fois, une demi-seconde plus tard. */
    function armerReprise(img, adresse) {
      if (!img || !adresse || img.getAttribute("data-reprise")) { return; }
      img.setAttribute("data-reprise", "1");
      img.addEventListener("error", function () {
        setTimeout(function () {
          img.src = adresse + (adresse.indexOf("?") < 0 ? "?" : "&") + "r=1";
        }, 500);
      }, { once: true });
    }

    /* ------------------------------------------------------ progression */
    /* Fraction du rail a remplir pour atteindre le centre du repere i.
       Mesuree, donc juste dans les deux canevas sans constante en dur.
       On mesure « .vm-rail », jamais « .vm-rail-fill » : ce dernier porte
       deja un scaleX(), sa largeur mesuree vaudrait donc zero. */
    function fraction(i) {
      var r = rail.getBoundingClientRect();
      var s = slots[i].getBoundingClientRect();
      if (!r.width) { return 0; }
      var p = (s.left + s.width / 2 - r.left) / r.width;
      return Math.max(0, Math.min(1, p));
    }

    /* ------------------------------------ morphing FLIP vers la vignette */
    function coordonnees(el) {
      var c = canvas.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      return {
        x: (r.left - c.left) / SCALE,
        y: (r.top - c.top) / SCALE,
        w: r.width / SCALE,
        h: r.height / SCALE
      };
    }

    function envoler(i) {
      var source = shots[i].querySelector("img") || shots[i].querySelector("video");
      var cible  = slots[i].querySelector(".vm-vig img");
      if (!source || !cible) { slots[i].classList.add("is-done"); return; }

      var src = coordonnees(source);
      var dst = coordonnees(cible);
      if (!src.w || !dst.w) { slots[i].classList.add("is-done"); return; }

      fly.src = shots[i].getAttribute("data-vignette");
      fly.style.left   = dst.x + "px";
      fly.style.top    = dst.y + "px";
      fly.style.width  = dst.w + "px";
      fly.style.height = dst.h + "px";
      fly.style.transform =
        "translate(" + (src.x - dst.x) + "px," + (src.y - dst.y) + "px) scale(" +
        (src.w / dst.w) + "," + (src.h / dst.h) + ")";
      fly.classList.remove("is-anim", "is-fade");
      fly.classList.add("is-live");
      void fly.offsetWidth;                       /* reflow : fige le depart */
      fly.classList.add("is-anim");
      fly.style.transform = "translate(0px,0px) scale(1,1)";

      a(POSE - 180, function () {
        slots[i].classList.add("is-done");
        fly.classList.add("is-fade");
      });
      a(POSE + 220, function () {
        fly.classList.remove("is-live", "is-anim", "is-fade");
      });
    }

    /* ---------------------------------------------------- etat d'arrivee */
    function etatFinal() {
      remiseAZero();
      for (var j = 0; j < N; j++) { precharger(j); }
      shots[N - 1].classList.add("is-on");
      caps[N - 1].classList.add("is-on");
      blocks[N - 1].classList.add("is-on");
      nums[N - 1].classList.add("is-on");
      for (var i = 0; i < slots.length; i++) {
        slots[i].classList.add("is-done");
        labs[i] && labs[i].classList.add("is-done");
      }
      railFill.style.transform = "scaleX(1)";
      final.classList.add("is-on");
    }

    /* --------------------------------------------------- la sequence */
    function etape(i) {
      var t = DEPART + i * ETAPE;

      a(t, function () {
        if (i > 0) {
          shots[i - 1].classList.remove("is-on");
          shots[i - 1].classList.add("is-past");
          caps[i - 1].classList.remove("is-on");
          caps[i - 1].classList.add("is-past");
          blocks[i - 1].classList.remove("is-on");
          blocks[i - 1].classList.add("is-past");
          nums[i - 1].classList.remove("is-on");
          nums[i - 1].classList.add("is-past");
          slots[i - 1].classList.remove("is-now");
          labs[i - 1] && labs[i - 1].classList.remove("is-now");
        }
        shots[i].classList.add("is-on");
        caps[i].classList.add("is-on");
        blocks[i].classList.add("is-on");
        nums[i].classList.add("is-on");
        slots[i].classList.add("is-now");
        if (labs[i]) { labs[i].classList.add("is-now"); labs[i].classList.add("is-done"); }
        railFill.style.transform = "scaleX(" + fraction(i) + ")";
        precharger(i + 1);
        if (i === 0 && video) {
          try { video.currentTime = 0; var p = video.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {}
        }
        if (i === 1 && video) { try { video.pause(); } catch (e) {} }
      });

      a(t + ENVOL, function () { envoler(i); });
    }

    function jouer() {
      remiseAZero();
      precharger(0);
      precharger(1);
      for (var i = 0; i < N; i++) { etape(i); }
      var fin = DEPART + (N - 1) * ETAPE + ENVOL + POSE + FIN;
      a(fin, function () {
        final.classList.add("is-on");
        slots[N - 1].classList.remove("is-now");
        labs[N - 1] && labs[N - 1].classList.remove("is-now");
      });
      if (boucle) { a(fin + REPRISE, jouer); }
    }

    /* --------------------------------------------------- mise en marche */
    var reduit = window.matchMedia &&
                 window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduit) {
      racine.classList.add("vm-fige");
      etatFinal();
      if (replay) { replay.addEventListener("click", etatFinal); }
      return;
    }

    if (replay) { replay.addEventListener("click", jouer); }

    /* On ne joue que lorsque la section est reellement a l'ecran : la
       sequence ne se consume pas avant que le visiteur y arrive, et rien
       ne tourne dans un onglet en arriere-plan. */
    var enMarche = false;
    if (window.IntersectionObserver) {
      var mediaCharge = false;
      var obs = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) {
            if (!mediaCharge && video) {
              mediaCharge = true;
              video.preload = "auto";
              try { video.load(); } catch (e) {}
            }
            if (!enMarche) { enMarche = true; fit(); jouer(); }
          } else if (enMarche) {
            enMarche = false;
            arreter();
            if (video) { try { video.pause(); } catch (e) {} }
          }
        }
      }, { threshold: 0.28 });
      obs.observe(racine);
    } else {
      jouer();
    }
  }

  function init() {
    var liste = document.querySelectorAll(".vd-motion-fleur-colis");
    for (var i = 0; i < liste.length; i++) { demarrer(liste[i]); }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  /* l'editeur de theme reconstruit la section sans recharger la page */
  document.addEventListener("shopify:section:load", init);
})();
